import update from 'immutability-helper';
// eslint-disable-next-line import/no-cycle
import {
  USERS_PROGRESS,
  USERS_SUCCESS,
  USERS_FAILED,
  USERS_GET_LIST_PROGRESS,
  USERS_GET_LIST_SUCCESS,
  USERS_GET_LIST_FAILED,
  USERS_FORM_SUBMIT_PROGRESS,
  USERS_FORM_SUBMIT_SUCCESS,
  USERS_FORM_SUBMIT_FAILED,
  USERS_GET_USER_PROGRESS,
  USERS_GET_USER_SUCCESS,
  USERS_GET_USER_FAILED,
  USERS_GET_ASYNC_DATA_PROGRESS,
  USERS_GET_ASYNC_DATA_SUCCESS,
  USERS_GET_ASYNC_DATA_FAILED,
  USERS_GET_STATISTICS_PROGRESS,
  USERS_GET_STATISTICS_SUCCESS,
  USERS_GET_STATISTICS_FAILED,
  USERS_CLEAR_STATE,
  USERS_CLEAR_FLASH_MESSAGE,
} from '../actions/usersAction';

const initialState = {
  loadListStatus: '', // progress/success/failed
  loadActiveStatus: '', // progress/success/failed
  submitStatus: '', // progress/success/failed
  asyncStatus: '', // progress/success/failed
  list: [],
  pagination: {},
  active: {},
  asyncData: {},
  flash: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case USERS_GET_LIST_PROGRESS: {
      return update(state, {
        list: { $set: [] },
        pagination: { $set: {} },
        loadListStatus: { $set: USERS_PROGRESS },
      });
    }
    case USERS_GET_LIST_SUCCESS: {
      return update(state, {
        list: { $set: action.payload.list },
        pagination: { $set: action.payload.pagination },
        loadListStatus: { $set: USERS_SUCCESS },
      });
    }
    case USERS_GET_LIST_FAILED: {
      return update(state, {
        list: { $set: [] },
        pagination: { $set: {} },
        loadListStatus: { $set: USERS_FAILED },
      });
    }
    case USERS_FORM_SUBMIT_PROGRESS: {
      return update(state, { submitStatus: { $set: USERS_PROGRESS } });
    }
    case USERS_FORM_SUBMIT_SUCCESS: {
      return update(state, {
        flash: { $set: action.payload },
        submitStatus: { $set: USERS_SUCCESS },
      });
    }
    case USERS_FORM_SUBMIT_FAILED: {
      return update(state, { submitStatus: { $set: USERS_FAILED } });
    }
    case USERS_GET_USER_PROGRESS: {
      return update(state, {
        active: { $set: {} },
        loadActiveStatus: { $set: USERS_PROGRESS },
      });
    }
    case USERS_GET_USER_SUCCESS: {
      return update(state, {
        active: { $set: action.payload.user },
        loadActiveStatus: { $set: USERS_SUCCESS },
      });
    }
    case USERS_GET_USER_FAILED: {
      return update(state, {
        active: { $set: {} },
        loadActiveStatus: { $set: USERS_FAILED },
      });
    }
    case USERS_GET_ASYNC_DATA_PROGRESS: {
      return update(state, {
        asyncData: { $set: {} },
        asyncStatus: { $set: USERS_PROGRESS },
      });
    }
    case USERS_GET_ASYNC_DATA_SUCCESS: {
      return update(state, {
        asyncData: { $set: action.payload },
        asyncStatus: { $set: USERS_SUCCESS },
      });
    }
    case USERS_GET_ASYNC_DATA_FAILED: {
      return update(state, {
        asyncData: { $set: {} },
        asyncStatus: { $set: USERS_FAILED },
      });
    }
    case USERS_GET_STATISTICS_PROGRESS: {
      return update(state, {
        active: { $set: {} },
        loadActiveStatus: { $set: USERS_PROGRESS },
      });
    }
    case USERS_GET_STATISTICS_SUCCESS: {
      return update(state, {
        active: { $set: { ...action.payload } },
        loadActiveStatus: { $set: USERS_SUCCESS },
      });
    }
    case USERS_GET_STATISTICS_FAILED: {
      return update(state, {
        active: { $set: {} },
        loadActiveStatus: { $set: USERS_FAILED },
      });
    }
    case USERS_CLEAR_STATE: {
      return update(state, {
        loadListStatus: { $set: '' },
        loadActiveStatus: { $set: '' },
        submitStatus: { $set: '' },
        asyncStatus: { $set: '' },
        list: { $set: [] },
        pagination: { $set: {} },
        active: { $set: {} },
        asyncData: { $set: {} },
      });
    }
    case USERS_CLEAR_FLASH_MESSAGE: {
      return update(state, {
        flash: { $set: '' },
      });
    }
    default:
      return state;
  }
}
